import NoteDialog from './NoteDialog';

export default NoteDialog;
